import { PlusOutlineIcon } from '@carboncopyco/icons';
import type { ButtonProps } from '@carboncopyco/ui';
import { Button, Tooltip, TooltipMessage } from '@carboncopyco/ui';
import { forwardRef, useRef } from 'react';

export interface AddRuleButtonProps
  extends Pick<ButtonProps, 'onClick' | 'disabled'> {
  tooltipMessage?: string;
}

export const AddRuleButton = forwardRef<HTMLButtonElement, AddRuleButtonProps>(
  ({ onClick, disabled, tooltipMessage }, ref) => {
    const buttonRef = useRef();

    return (
      <>
        <div
          className="py-ds-p-7"
          ref={buttonRef}
        >
          <Button
            ref={ref}
            link
            blue
            small
            leftIcon={<PlusOutlineIcon />}
            label="Add"
            onClick={onClick}
            noPadding
            disabled={disabled}
          />
        </div>
        {tooltipMessage && (
          <Tooltip
            shadow="md"
            anchorRef={buttonRef}
            placement="bottom-start"
            autoCalcArrowPosition
          >
            <TooltipMessage title={tooltipMessage} />
          </Tooltip>
        )}
      </>
    );
  }
);
AddRuleButton.displayName = 'AddRuleButton';
